class WatchManuals extends HTMLElement {
  constructor() {
    super()
    this.input = this.querySelector('.js-manuals-search-details-input')
    this.list = this.querySelector('[data-manual-list]')
    this.items = []
    this.handlePrefix = this.dataset.handlePrefix || 'product-manual-'
    this.checkNoResult = this.checkNoResult.bind(this)
  }

  async connectedCallback() {
    this.onInputHandler = this.onInputHandler.bind(this)
    this.input.addEventListener('input', this.onInputHandler)
    await this.fetchCollections()
  }

  disconnectedCallback() {
    this.input.removeEventListener('input', this.onInputHandler)
  }

  async fetchCollections() {
  const loader = this.querySelector('[data-manual-loader]')
  try {
    let page = 1
    const limit = 250
    let hasMore = true
    const handles = []

    while (hasMore) {
      const res = await fetch(`/collections.json?limit=${limit}&page=${page}`)
      const { collections } = await res.json()
      collections
        .filter(c => c.handle.startsWith(this.handlePrefix))
        .forEach(c => handles.push(c.handle))
      hasMore = collections.length === limit
      page++
    }

    if (handles.length === 0 && loader) loader.classList.add('hidden')  // ← hide if no results

    const BATCH = 40
    for (let i = 0; i < handles.length; i += BATCH) {
      const batch = handles.slice(i, i + BATCH)
      const htmls = await Promise.all(
        batch.map(handle =>
          fetch(`/collections/${handle}?view=manual-item`).then(r => r.text())
        )
      )
      htmls.forEach(html => this.list.insertAdjacentHTML('beforeend', html))

      if (i === 0 && loader) loader.classList.add('hidden')  // ← hide after first batch
    }

    this.items = [...this.querySelectorAll('.js-manuals-item')]
  } catch (err) {
    console.error('[WatchManuals] Failed to load manuals:', err)
    if (loader) loader.classList.add('hidden')  // ← still hide on error
  }
}

  onInputHandler(e) {
    const term = String(e.target.value).trim().toLowerCase()
    this.items.forEach(item => {
      const match =
        item.dataset.manualTitle.includes(term) ||
        item.dataset.manualFeatures.includes(term) ||
        item.dataset.legacySkus.includes(term) ||
        item.dataset.productTitles.includes(term) ||
        item.dataset.productSkus.includes(term) ||
        item.dataset.specs.includes(term)
      item.classList.toggle('hidden', !match)
    })
    this.checkNoResult()
  }

  checkNoResult() {
    const visible = [...this.items].filter(i => !i.classList.contains('hidden'))
    this.classList.toggle('watch-manuals__no-result', visible.length === 0)
  }
}

customElements.define('watch-manuals', WatchManuals)
